import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import LocalTopTips from "../components/LocalTopTips.vue";
import SelectClassify from "@/components/SelectClassify/index.vue";
import TransferDialog from "../components/TransferDialog.vue";
import QuestionForm from "../components/QuestionForm.vue";
import { AppModule } from "@/store/modules/app";
import { QUESTION_TYPE_MAP } from "../constant";
import { getQuestionDetail, transferQuestion } from "@/api/question";
import { checkSession } from "@/api/commom";
import eventEmitter from "@/utils/eventEmitter";
let QuestionEdit = class QuestionEdit extends Vue {
    constructor() {
        super(...arguments);
        this.showDialog = false;
        this.topicTypeName = '';
        this.parentID = '';
        this.hasShowForm = false;
        this.questionBankId = '';
        this.questionBankParentId = '0';
        this.dialogLoading = false;
        this.isReference = false;
        this.isLoading = false;
        this.aliveInterval = null;
        this.shouldDialogShow = true;
    }
    get mapType() {
        const type = QUESTION_TYPE_MAP.find((t) => t.id === this.type);
        return type && type.text || '';
    }
    get isEdit() {
        const query = this.$route.query;
        return query.is_edit != null ? Number(query.is_edit) : Number(sessionStorage.getItem("isEdit"));
    }
    get questionId() {
        return sessionStorage.getItem("questionId") || this.$route.query.questionId || '';
    }
    get type() {
        const query = this.$route.query;
        return query.type != null ? Number(query.type) : Number(sessionStorage.getItem("type"));
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    created() {
        const query = this.$route.query;
        sessionStorage.setItem("type", query.type);
        sessionStorage.setItem("isEdit", query.is_edit);
        sessionStorage.setItem("questionId", query.question_id);
        // this.questionBankId = decodeURI(this.getQueryString("questionBankId")) || ""
        this.questionBankId = query.question_bank_id || '';
        this.aliveInterval = setInterval(() => {
            checkSession();
        }, 30 * 1000);
        if (this.interceptRoute) {
            eventEmitter.on('routerRapture', () => this.shouldDialogShow ? Promise.reject() : Promise.resolve());
        }
    }
    mounted() {
        // window.getSaveFlag = function () {
        //   return true
        // }
        // this.gooseClass && window.addEventListener("message", this.getInfo, true)
        this.$nextTick(() => {
            this.hasShowForm = true;
            this.handleGetQuesLibInfo();
        });
    }
    beforeDestroy() {
        clearInterval(this.aliveInterval);
    }
    save() {
        this.shouldDialogShow = false;
        this.form.save();
        // if (this.gooseClass) {
        //   window.parent.postMessage({
        //     cmd: 'saveQuestionSuccess',
        //     params: { loading: false }
        //   }, window.location.origin)
        // }
    }
    cancel() {
        this.shouldDialogShow = true;
        this.form.cancel();
    }
    handleGetQuesReference(data) {
        this.isReference = data.isReference;
    }
    async handleGetQuesLibInfo() {
        if (!this.isEdit || !this.questionId)
            return;
        this.isLoading = true;
        try {
            const res = await getQuestionDetail(this.questionId);
            const data = res.data.data;
            this.topicTypeName = data.categoryName;
            this.questionBankId = data.categoryId;
            this.questionBankParentId = data.categoryParentId || '0';
            this.isLoading = false;
        }
        catch (error) {
            console.error(error);
            this.topicTypeName = '默认分类';
            this.questionBankId = '1';
            this.questionBankParentId = '0';
        }
    }
    async handleCheckedClasses(nodeData) {
        const questionBankId = nodeData.id;
        const topicTypeName = nodeData.name;
        const questionBankParentId = nodeData.parentId;
        if (!this.isEdit) {
            this.topicTypeName = topicTypeName;
            this.questionBankId = questionBankId;
            this.showDialog = false;
            return;
        }
        const oldQuestionBankId = this.questionBankId;
        this.questionBankId = questionBankId;
        try {
            await transferQuestion([this.questionId], questionBankId);
            this.$message.success("题目转移成功！");
            this.topicTypeName = topicTypeName;
            this.questionBankParentId = questionBankParentId;
            this.showDialog = false;
        }
        catch (error) {
            this.questionBankId = oldQuestionBankId;
        }
    }
    handleSelect() {
        this.showDialog = true;
    }
};
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], QuestionEdit.prototype, "interceptRoute", void 0);
tslib_1.__decorate([
    Ref()
], QuestionEdit.prototype, "form", void 0);
QuestionEdit = tslib_1.__decorate([
    Component({
        name: 'QuestionEdit',
        components: {
            QuestionForm,
            TransferDialog,
            LocalTopTips,
            SelectClassify
        },
        beforeRouteEnter(to, from, next) {
            sessionStorage.setItem('from-router', JSON.stringify({
                path: from.path,
                query: from.query,
                params: from.params,
                meta: from.meta
            }));
            next();
        },
    })
], QuestionEdit);
export default QuestionEdit;
